import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { AddFill, SearchLineIcon } from '../../../components/icon/icon';
import { SearchCondition } from '../../../components/common/common.search.condition';
import { useHistory } from 'react-router-dom';
import { fetchCompanyOrders } from '../../../api/order';
import { ManagerOrderItem } from '../../../components/user/order/manager.order.section';

interface OrderResponse {
  id: number;
  target: string;
  wanted: string;
  work: string;
  type: string;
  amount: number;
  totalVehicle: number;
  remainingVehicle: number;
}

const ManagerOrder = () => {
  const history = useHistory();
  const [searchOpen, setSearchOpen] = useState(false);
  const [orders, setOrders] = useState<OrderResponse[]>([]); // 발주 내역을 저장할 상태
  const [loading, setLoading] = useState(true); // 로딩 상태 관리

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const handleSearchSubmit = async (startDate: Date, endDate: Date) => {
    // 검색 조건이 제출될 때 처리하는 함수
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    setStartDate(formatDate(startDate));
    setEndDate(formatDate(endDate));
    setSearchOpen(false);
  };

  const handleSearchClick = () => {
    setSearchOpen(true);
  };
  const handleSearchClose = () => {
    setSearchOpen(false);
  };
  const registBtnClicked = () => {
    history.push('/managerOrder/regist');
  };

  // 오늘 부터 일주일 이후 데이터 가져오기
  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);

        const today = new Date();
        const weekLater = new Date(today);
        weekLater.setDate(today.getDate() + 7);

        const formatDate = (date: Date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const startDateString = startDate || formatDate(today);
        const endDateString = endDate || formatDate(weekLater);

        const data = await fetchCompanyOrders({
          startDate: startDateString,
          endDate: endDateString,
        });

        setOrders(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    getOrders();
  }, [startDate, endDate]);

  if (loading) return <p>Loading...</p>;
  return (
    <Container>
      <SearchForm onClick={handleSearchClick}>
        <span>검색</span>
        <div className="icon-box">
          <SearchLineIcon />
        </div>
      </SearchForm>
      <ManagerOrderItem items={orders} authInfo="manager" />
      <div className="btn-box">
        <button onClick={registBtnClicked}>
          <AddFill />
        </button>
      </div>
      <AnimatePresence initial={false}>
        {searchOpen ? (
          <SearchConditionWrap
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              type: 'fade',
            }}
          >
            <SearchCondition
              handleSearchClose={handleSearchClose}
              handleSearchSubmit={handleSearchSubmit}
            />
          </SearchConditionWrap>
        ) : null}
      </AnimatePresence>
    </Container>
  );
};

export default ManagerOrder;

// style
const Container = styled.div`
  height: calc(100% - 16rem);
  padding: 0 1.5rem;
  .btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 11rem;
    right: 2rem;
    button {
      width: 6.2rem;
      height: 6.2rem;
      border-radius: 6rem;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 5px 1px rgba(0, 0, 0, 0.1);
      background-color: ${(props) => props.theme.btnBlueColor};
    }
  }
`;

const SearchForm = styled.div`
  background-color: ${(props) => props.theme.homeMainBoxBgColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 1.2rem;
  overflow: hidden;
  margin-top: 1.5rem;
  margin-bottom: 1.2rem;
  span {
    padding: 1.3rem;
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.3rem;
    color: ${(props) => props.theme.textWhiteColor};
  }
  .icon-box {
    display: flex;
  }
`;

const SearchConditionWrap = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: 'flex';
  justify-content: 'center';
  align-items: 'center';
  cursor: 'pointer';
  width: 100%;
  height: 100%;
  .overlay {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
